import FieldLabel from '../forms/FieldLabel';
import { useState } from "react";
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';
import AdminIconButton from './AdminIconButton';
import {
  formatDimensions,
  formatFileSize,
  presskitObjectUrl,
  presskitThumbnailUrl,
} from "../../api/presskit";
import { presskitAcceptByType } from "./presskitMediaConfig";

export default function PresskitMediaCard({
  asset,
  index,
  total,
  busy,
  dragging,
  onDelete,
  onDescription,
  onDimensions,
  onDragEnd,
  onDragEnter,
  onDragStart,
  onMove,
  onReplace,
  onVisibility,
}) {
  const [description, setDescription] = useState(asset.altText);
  const fileName = asset.objectPath.split("/").pop();
  const typeLabel = asset.mediaType === "image" ? "Photo" : "Video";

  return (
    <article
      className={`admin-media-card admin-sortable-item${asset.isVisible ? "" : " is-hidden"}${dragging ? " is-dragging" : ""}`}
      onDragEnter={() => onDragEnter(asset)}
    >
      <div
        className={`admin-media-preview${busy ? "" : " admin-drag-source"}`}
        draggable={!busy}
        title={busy ? undefined : `Drag ${typeLabel.toLowerCase()} ${index + 1} to reorder`}
        onDragStart={(event) => onDragStart(asset, event)}
        onDragEnd={onDragEnd}
      >
        {asset.mediaType === "image" ? (
          <img src={presskitThumbnailUrl(asset)} alt="" draggable="false" />
        ) : (
          <video
            src={presskitObjectUrl(asset)}
            controls
            draggable="false"
            preload="metadata"
            aria-label={asset.altText}
            onLoadedMetadata={(event) => onDimensions(asset, {
              width: event.currentTarget.videoWidth,
              height: event.currentTarget.videoHeight,
              durationSeconds: Number.isFinite(event.currentTarget.duration) ? event.currentTarget.duration : null,
            })}
          />
        )}
        <span className={`admin-media-visibility ${asset.isVisible ? "visible" : "hidden"}`}>
          {asset.isVisible ? "Published" : "Hidden"}
        </span>
      </div>

      <div className="admin-media-body">
        <strong>{typeLabel} {index + 1}</strong>
        <span className="admin-media-filename" title={fileName}>{fileName}</span>
        <span>{formatDimensions(asset)} · {formatFileSize(asset.sizeBytes)}</span>
        <span>{asset.mimeType}</span>

        <FieldLabel>
          {asset.mediaType === "image" ? "Descriptive alt text" : "Video description"}
          <textarea required rows="3" maxLength="500" value={description} onChange={(event) => setDescription(event.target.value)} />
        </FieldLabel>
        <button
          type="button"
          onClick={() => onDescription(asset, description)}
          disabled={busy || !description.trim() || description.trim() === asset.altText}
        >
          Save description
        </button>

        <div className="admin-media-order" aria-label={`Reorder ${asset.altText}`}>
          <AdminIconButton label="Move earlier" icon={FiArrowUp} onClick={() => onMove(asset, -1)} disabled={busy || index === 0} />
          <AdminIconButton label="Move later" icon={FiArrowDown} onClick={() => onMove(asset, 1)} disabled={busy || index === total - 1} />
        </div>

        <div className="admin-media-actions">
          <button type="button" onClick={() => onVisibility(asset)} disabled={busy}>
            {asset.isVisible ? "Hide" : "Show"}
          </button>
          <label className={`admin-file-button${busy ? " disabled" : ""}`}>
            Replace
            <input
              type="file"
              accept={presskitAcceptByType[asset.mediaType]}
              disabled={busy}
              onChange={(event) => {
                const file = event.target.files?.[0];
                event.target.value = "";
                if (file) onReplace(asset, file);
              }}
            />
          </label>
          <button type="button" className="admin-danger" onClick={() => onDelete(asset)} disabled={busy}>Delete</button>
        </div>
      </div>
    </article>
  );
}
